import { USER } from '../../constants/user.constants';
import { SOCIAL_LOGIN } from '../../constants/social-login.constants';
import { actionTypes } from 'actions/account/actionTypes';

const initialState = {
  loading: false,
  data: {},
  loginType: '',
  error: '',
};

export function user(state: any = initialState, action: any) {
  switch (action.type) {
    case USER.LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        data: {},
        loginType: '',
        error: '',
      };
    case actionTypes.REFRESH_TOKEN_SUCCESS: {
      return {
        ...state,
        data: action.payload
      }
    }
    case USER.LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.user,
        loginType: '',
        error: '',
      };
    case USER.LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        data: {},
        loginType: '',
        error: action.error,
      };

    case SOCIAL_LOGIN.SOCIAL_LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        data: {},
        loginType: '',
        error: '',
      };

    case SOCIAL_LOGIN.SOCIAL_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.user,
        loginType: action.socialType,
        error: '',
      };

    case SOCIAL_LOGIN.SOCIAL_LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        data: {},
        loginType: '',
        error: action.error,
      };
    case actionTypes.CLEAR_LOADING_LOGIN: {
      return {
        ...state,
        loading: false
      }
    }
    case USER.LOGOUT_SUCCESS:
      return initialState;
    default:
      return state;
  }
}
